<div *ngIf="listing" class="_flex _justify-center sm:_justify-start">
    <h1 class="_text-h4-m md:_text-h2 _tracking-normal _text-center xs:_text-left">
        {{listing.summary.title}}
    </h1>
</div>
